export default "__VITE_ASSET__B012xOb2__"